export default __webpack_public_path__ + "static/ASLA_Radia_3a-1084cdb0eed3f885a46f3c9283ea0ab3.png";